import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import CloseIcon from '../../../svg/close.svg';

const LightBoxSecond = ({ currentImage, closeModal, showLightbox }) => {
  const image = getImage(currentImage);
  return (
    <div className={showLightbox ? 'lightbox is-show' : 'lightbox'}>
      <div
        className="lightbox-overlay"
        onClick={closeModal}
        role="presentation"
      ></div>
      <div className="lightbox-wrapper">
        <button className="light-box__close" onClick={closeModal}>
          <span className="light-box__close-icon">
            <CloseIcon />
          </span>
        </button>
        <div className="lightbox-image__wrapper">
          <GatsbyImage
            image={image}
            className="lightBox-image"
            alt="best foto"
          />
        </div>
      </div>
    </div>
  );
};

LightBoxSecond.propTypes = {
  closeModal: PropTypes.func,
  showLightbox: PropTypes.bool,
};

export default LightBoxSecond;
